module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-5.de09fddd.jpg";